module.exports = __webpack_public_path__ + "static/media/chulizhong.af90ba5a.svg";